/* eslint-disable import/no-anonymous-default-export */
export default {
  LOREM_IPSUM: 'Lorem ipsum',
  //---A---//
  ACCEPT: 'Accept',
  ACTIONS: 'Actions',
  ADD_FILTERS: 'Add filters',
  API_DOCUMENTATION: 'API documentation',
  ADVANCED: 'Advanced',
  AUTO_BRANDED_LINKS: 'Auto-Branded Links',
  APPLY: 'Apply',
  ALL: 'All',
  ANALYZE: 'Analyze',
  ANALISYS_TRACKING: 'Advanced analysis and tracking',
  ACCOUNT_DETAILS: 'Account details',
  ACCOUNT_SETTINGS: 'Account settings',
  APRIL: 'April',
  AUGUST: 'August',
  ADD_TAG: 'Add tag',
  ACTIVES: 'Actives',
  ACTIVATE: 'Activate',
  ACCESS_PLAN: 'Access to detailed statistics',
  //---B---//
  BASIC: 'Basic',
  BACK_HALF: 'Custom half',
  BULK_SHORTERING: 'Bulk Shortening',
  BRANDED_LINKS: 'Advanced link and brand customization',
  BRANDED_CUSTOM_LINKS: 'Branded custom links',
  BENEFITS_INFO_TITLE:
    'With <span class="color-primary">our</span> <br> <span class="color-secondary"> platform</span> you will be able to:',
  BENEFITS_INFO_1: 'With our link shortening platform you will be able to:',
  BENEFITS_INFO_2: 'Turn those long URLs into short, friendly links.',
  BENEFITS_INFO_3:
    'Modify colors, styles and brand the links with your personal brand.',
  BENEFITS_INFO_4:
    'Share dynamic QR codes that generate interaction with your content.',
  BENEFITS_INFO_5: 'Track your links to optimize strategies.',
  BILLING_AND_USAGE: 'Billing and usage',
  BIG_SIZE: 'Big size',
  //---C---//
  CHANGING_PLAN: 'Your plan is been updated',
  CHANGE_PLAN_QR: 'Update your plan to create QR codes',
  CHANGE_STATUS: 'Change status',
  CREDITS: 'Credits',
  CREDITS_URL: 'URLs remaining credits',
  CREDITS_QR: 'QR codes remaining credits',
  CAMPAIGN: 'Campaign',
  CLEAR_FILTERS: 'Clear filters',
  CANCEL: 'Cancel',
  CLICS: 'clics',
  CREATE: 'Create',
  CREATE_NEW: 'Create new',
  CREATE_URL: 'Create URL',
  CREATE_QR_CODE: 'Create QR codes',
  CREATE_URL_SHORT: 'Create short URL',
  CREATE_URL_CUSTOM: 'Create custom URL',
  CREATED_LINKS: 'URL created',
  CREATED_QR_CODES: 'QR codes created',
  CUSTOM: 'Custom',
  CUSTOM_LINKS: 'Custom links',
  CUSTOM_BACK_HALVES: 'Custom Back-Halves',
  CREATE_COPY: 'Create a copy',
  COPY: 'Copy',
  COPY_LINK: 'Copy link',
  CONTENT: 'Content',
  COLOR: 'Color',
  CUSTOM_DOMAINS: 'Custom domains',
  CURRENT_PASSWORD: 'Current password',
  CHANGE_PASSWORD: 'Change password',
  CONFIRM_NEW_PASSWORD: 'Confirm new password',
  COOKIE_PARAGRAPH: 'Accept cookies',
  CLEAN_ALL_FILTERS: 'Clean all filters',
  CONVERT_LINKS: 'Convert links',
  CLIENT: 'Customer',
  CLIENTS_INFO:
    'Some of the <span class="color-primary"> customers</span> that <span class="color-red">trust</span> our <span class="color-primary">service</ span>',
  CLICKS_BY_TIME: 'Clicks over time',
  CLICKS_BY_LOCATION: 'Clicks by location',
  COUNTRY: 'Country',
  CLICKS: 'Clicks',
  //---D---//
  DEACTIVATE: 'Deactivate',
  DATA_SAVED: 'Information has been saved successfully',
  DATA_UPDATED: 'Information has been updated successfully',
  DATA_DELETED: 'Information has been deleted successfully',
  DECEMBER: 'December',
  DAYS_UP_TO_TODAY: 'days up to today',
  DAYS_STARTING_TODAY: 'days starting today',
  DASHBOARD: 'Dashboard',
  DATE: 'Date',
  DELETE: 'Delete',
  DELETE_LINK: 'Delete link',
  DELETE_QR_CODE: 'Delete QR code',
  DELETE_PARAGRAPH_1:
    'Removing this link will redirect anyone who clicks on it to an error page.',
  DELETE_QR_PARAGRAPH_1:
    'Removing this QR code will redirect anyone who clicks on it to an error page.',
  DELETE_PARAGRAPH_2: 'This action cannot be undone.',
  DELETE_PARAGRAPH_3: 'Are you sure you want to delete this link?',
  DELETE_QR_PARAGRAPH_3: 'Are you sure you want to delete this QR code?',
  DESTINATION: 'Destination',
  DESTINATION_QR: 'Enter the destination of your QR code',
  DOMAIN: 'Domain',
  DOMAINS: 'Domains',
  DONT_HAVE_AN_ACCOUNT: "Don't have an account?",
  DISPLAY_NAME: 'Display name',
  DOWNLOAD: 'Download',
  DOWNLOAD_JPEG: 'Download JPEG',
  DOWNLOAD_PNG: 'Download PNG',
  DOWNLOAD_YOUR_QR_CODE: 'Download your QR code',
  DOWNLOAD_QR_CODE: 'Download QR code',
  DELETE_LOGO: 'Delete logo',
  DOMAIN_CANT_BE_CHANGED: "*Domain can't be changed once created",
  //---E---//
  ERROR_HEXADECIMAL_COLOR: 'The hexadecimal color entered is invalid.',
  ENTER_TAG: 'Enter the tag and press ENTER.',
  ELEVATE_CONECTIONS_TITLE_1: 'Elevate your connections',
  ELEVATE_CONECTIONS_TITLE_2: 'with Altera',
  ELEVATE_CONECTIONS_INFO_1:
    'Create <strong>smart links</strong> and <strong>dynamic QR codes</strong>',
  ELEVATE_CONECTIONS_INFO_2:
    'Amplify your presence by sharing them anywhere with ease',
  ELEVATE_CONECTIONS_3:
    "Perform a <strong>detailed follow-up</strong> to asses what works and improve what doesn't",
  ELEVATE_CONECTIONS_INFO_4:
    'Make every connection count on the innovative Altera Platform!',
  EDIT: 'Edit',
  EDIT_LINK: 'Edit link',
  EMAIL: 'Email',
  EMAIL_USERNAME_OR_PASSWORD_INCORRECT:
    'Email/usename or password is incorrect. Please try again.',
  EG_GOOGLE_NEWSLETTER: 'e.g. google, newsletter',
  EG_BANNER_EMAIL: 'e.g. banner, email',
  EG_BLACK_FRIDAY: 'e.g. black Friday',
  EG_SOMETHING: 'e.g. something',
  EG_SOMETHING_ELSE: 'e.g. something else',
  EDIT_QR_CODE: 'Edit QR code',
  EXPORT_CSV: 'Export .csv',
  EDIT_LOGO: 'Edit logo',
  ERROR: 'An error has occurred, please contact the administrator',
  ENTER_URL_BEFORE_ACTIVATING_QR_CODE:
    'Please, enter an URL before select this option',
  EMAIL_PRIORITY: 'Priority email support',
  EMAIL_SUPPORT: 'Email support',
  //---F---//
  FREE: 'Free',
  FEBRAURY: 'Febraury',
  FILTERS: 'Filters',
  FILTER_BY_DATE: 'Filter by date',
  FILL_VALUES: 'Please enter the data',
  FILL_TAGS: 'Please fill the tags',
  FROM: 'from',
  //---G---//
  GET_A_QUOTE: 'Get a quote',
  GET_STARTED: 'Get started',
  GET_STARTED_FOR_FREE: 'Get started for free',
  GO_TO_QR_CODES: 'Go to QR codes',
  GO_TO_LINKS: 'Go to URLs',
  GO_TO_LINK: 'Go to the URL',
  GO_BACK_LINKS: '< Back to the list of links',
  GO_BACK_QRS: '< Back to the list of qr codes',
  //---H---//
  HAVE_AN_ACCOUNT: 'Have an account?',
  HELP: 'Help',
  HOME: 'Home',
  HIGH_QUALITY: 'High quality',
  //---I---//
  INTERACTIONS_BY_REFERRAL: '<strong>Interactions</strong><br> by referral',
  INTERACTIONS_TOTAL: 'Total interactions',
  INCLUDE_FILTERS: 'Include filters',
  INACTIVES: 'Inactives',
  //---J---//
  JANUARY: 'January',
  JUNE: 'June',
  JULY: 'July',
  //---K---//

  //---L---//
  LABELS: 'Labels',
  LAST_MONTH: 'Last Month',
  LAST_WEEK: 'Last Week',
  LINK: 'Link',
  LINKS: 'Links',
  LINKS_REDIRECT: 'Link Redirects',
  LINKS_CLICKS: 'Unlimited Link Clicks',
  LINKS_EXPORT: 'Links export',
  LINKS_WITH_CUSTOM_BACK_HALVES: 'Links with custom back-halves',
  LINKS_WITHOUT_CUSTOM_BACK_HALVES: 'Links without custom back-halves',
  LINK_DETAIL: 'Link detail',
  LOGIN: 'Log in',
  LOGOUT: 'Log out',
  LOG_IN_WITH_GOOGLE: 'Log in with Google',
  LOADING: 'Loading',
  LOGO: 'Logo',
  LOGIN_AFTER_CHANGE_PASSWORD:
    'You will be required to login after changing your password',
  LOW_QUALITY: 'Low quality',
  LINK_COPIED: 'Your URL has been successfully copied',
  LIMITED_ACCESS: 'Limited access to customization tools',
  //---M---//
  MAY: 'May',
  MARCH: 'March',
  MEDIUM: 'Medium',
  MONTH: 'Month',
  MOST_POPULAR: 'Most popular',
  MY_LONG_URL: 'My long url',
  MY_CUSTOM_URL: 'Custom back-half',
  MOBILE_DEEP_LINKS: 'Mobile Deep Links',
  //---N---//
  NO_DATA_AVAILABLE: 'No data',
  NAME: 'Name',
  NO_TAGS: 'No tags',
  NEW_PASSWORD: 'New password',
  NOVEMBER: 'November',
  NO_DATA: 'No data available',
  //---O---//
  OR: 'O',
  ORIGINAL_LINK: 'Original URL',
  OPTIONAL: 'optional',
  OCTOBER: 'October',
  //---P---//
  PLAN_CHANGED: 'Your plan has been changed',
  PLAN: 'Plan',
  PLANS: 'See Plans',
  PAY_ANNUALY: 'Pay annualy',
  PAY_MONTHLY: 'Pay monthly',
  PASSWORD: 'Password',
  PRICING: 'Pricing',
  PRODUCTS: 'Products',
  PROFESSIONAL: 'Professional',
  PREVIEW: 'Preview',
  PREVIEW_QR_CODE: '*This is a preview of your QR code',
  PROFILE: 'Profile',
  PREFERENCES: 'Preferences',
  PASSWORD_DO_NOT_MATCH: 'Passwords do not match',
  PASSWORD_RULES_1:
    'Password:8+ characters, 1 uppercase, 1 lowercase, 1 number,',
  PASSWORD_RULES_2: '1 special character (e.g., !, @, #, $,), no spaces.',
  PASSWORD_RULE:
    'The password must contain: 8+ characters, 1 uppercase, 1 lowercase, 1 number, 1 special character (e.g., !, @, #, $,), no spaces.',

  PERCENTAGE: 'Percentage',
  POPULAR_FUNCTIONS: 'Popular functions',
  //---Q---//
  QR_CREATED: 'Your QR code has been successfully created!',
  QR_CODE: 'QR Code',
  QR_CODES: 'QR Codes',
  QR_CODE_INFO:
    'Generate a QR code to <strong>share anywhere</strong> so <strong>people can scan it</strong>',
  QR_CUSTOMIZABLE: 'Fully customizable QR codes',
  QR_DYNAMIC: 'Dynamic QR codes',
  QR_TYPES: 'QR code types and destination options',
  QR_CODE_COLOR: 'Code color',
  QR_CODE_DETAIL: 'Qr detail',
  QR_CODE_CHARACTERISTICS:
    '*File type:PNG. Aspect 1:1.Max size:5MB, 2500x2500px',
  QR_WARNING_CREATION:
    'Consider the color contrast to avoid issues when scanning your code.',
  QR_CODE_LOGO_INFO:
    '*Use your own logo image .png, .jpg, .gif or .svg File format maximum size 2 MB.',
  QR_CODE_UPDATE_INFO:
    '*The short URL cannot be changed once the QR code is created',
  QR_CODE_EDIT: 'Edit code color',
  //---R---//
  REVIEW_LINKS: 'You can see it on your <strong>links page</strong>',
  REDIRECT: 'Redirect',
  REGISTER: 'User register',
  RESOURCES: 'Resources',
  REGISTER_FIRST_URL: 'Register to get your short URL',
  REGISTER_FIRST_QR: 'Register to get your code',
  REPORTS: 'Monthly performance reports',
  //---S---//
  SELECT: 'Select',
  SELECT_URL: 'Please, select the links',
  SELECT_ALL: 'Select all',
  START_HERE: 'Start here',
  SAVE: 'Save',
  SELECT_TAG: 'Select tag',
  SEE_HERE: 'See here',
  SETTINGS: 'Settings',
  START: 'Start session',
  SHOW: 'Show',
  SHORT_LINK: 'Short URL',
  SHOW_PASSWORD: 'Show password',
  SIGN_UP: 'Sign up',
  SUPPORT: 'Support',
  SOURCE: 'Origen',
  SHORT_URL_SCALE: 'URL shortening at scale',
  SHOW_LOGO_COMPANY: 'Show logo Altera',
  SECURITY_AND_AUTHENTICATION: 'Security and authentication',
  SELECT_FORMAT: 'Please select a format',
  SEARCH: 'Search',
  SEPTEMBER: 'September',
  SMALL_SIZE: 'Small size',
  SCAN_BY_TIME: 'Scan over time',
  SCAN_BY_LOCATION: 'Scan by location',
  SCAN: 'Scans',
  STATUS_CHANGED: 'Status was changed successfully',
  STATISTICS: 'Statistics',
  SUPPORT_24_7: 'Support 24/7',
  //---T---//
  TAGS_ADDED: 'Tags added successfully',
  TAGS: 'Tags',
  THIS_MONTH: 'This Month',
  THIS_WEEK: 'This Week',
  TERMS_AND_CONDITIONS: 'Terms and conditions',
  TITLE: 'Title',
  TODAY: 'Today',
  TYPES: 'Types',
  TERM: 'Term',
  TRANSPARENT_BACKGROUND: 'Transparent background',
  TODAY_STATISTICS: "Today's statistics",
  TOTAL: 'Total',
  TO: 'to',
  //---U---//
  URL_IS_BEING_CREATED: 'Your URL is being created',
  URL_SHORT: 'Short URL',
  URL_CREATED: 'Your URL has been created successfully!',
  USER: 'User',
  UNLIMITED: 'Unlimited',
  URL_TYPE: 'URL type',
  USER_REGISTER_SUCCESSFULL: 'Registered user successfully',
  USER_ALREADY_EXIST: 'User already exist',
  USER_ALREADY_EXIST_GO_TO_THE_LOGIN:
    'User already exist, please go to the log in',
  USER_DO_NOT_EXIST: 'User do not exist',
  USER_DO_NOT_EXIST_PLEASE_SIGN_UP: 'User do not exist, please sign up',
  UTM: 'UTM data',
  UTM_INFO:
    'Add <strong>UTM</strong> to <strong>track web traffic</strong> in analytics tools',
  UTM_TAG_PREVIEW: 'UTM tag preview',
  UTM_TAG_PREVIEW_QUESTION:
    'This is how your UTM parameters will appear at the end of your destination URL',
  UPDATE: 'Update',
  UPDATE_PLAN: 'Update plan',
  UPDATE_PASSWORD: 'Update password',
  UPLOAD_YOUR_LOGO: 'Upload your logo',
  USER_NOT_FOUND: 'Unauthorized user',
  //---V---//
  VIEW_LINK_DETAIL: 'View link detail',
  VIEW_QR_CODE_DETAIL: 'View QR code',
  VIEW_DETAIL: 'View detail',
  //---W---//
  WHAT_CREATE:
    'What would you like <span class="color-primary">to create</span>?',
  WAYS_TO_SHARE: 'Ways to share',
  WHY_ALTERA: 'Why Altera',
  WELCOME_TO_ALTERA:
    'Welcome to <span class="color-secondary">Altera Links</span>!',
  WELCOME_TO_ALTERA_INFO_1:
    '<strong>Tired of long and complicated links?</strong> We have the perfect solution for you!',
  WELCOME_TO_ALTERA_INFO_2:
    'At Altera, we offer a cutting-edge <strong>URL shortening</strong> tool, designed to <strong>simplify and enhance</strong> your online connections.',
  //---X---//

  //---Y---//
  YES_DELETE: 'Yes, I want to delete it',
  YESTERDAY: 'Yesterday',
  YEAR: 'Year',
  YOUR_SETTINGS: 'Your settings',
  YOUR_CREATIONS: 'Your creations',
  //---Z---//
}
